"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDrillToCustomUrl = exports.getInsightIdentifiersReplacements = exports.getAttributeIdentifiersReplacements = exports.getAttributeDisplayForms = exports.loadAttributeElementsForDrillIntersection = exports.splitDFToLoadingAndMapping = exports.loadElementTitle = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var effects_1 = require("redux-saga/effects");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var metaSelectors_1 = require("../../store/meta/metaSelectors");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var insightsSelectors_1 = require("../../store/insights/insightsSelectors");
var getElementTitle_1 = require("./getElementTitle");
var drillingUtils_1 = require("../../../_staging/drills/drillingUtils");
var general_1 = require("../../events/general");
var catalogSelectors_1 = require("../../store/catalog/catalogSelectors");
var groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
var drillTypes_1 = require("../../types/drillTypes");
function loadElementTitle(dfRef, dfIdentifier, attrElementUri, ctx) {
    var elementTitle;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(getElementTitle_1.getElementTitle, ctx.workspace, dfRef, attrElementUri, ctx)];
            case 1:
                elementTitle = _a.sent();
                return [2 /*return*/, {
                        identifier: dfIdentifier,
                        elementTitle: elementTitle,
                    }];
        }
    });
}
exports.loadElementTitle = loadElementTitle;
function isInRefList(list, ref) {
    return list.some(function (itemRef) { return sdk_model_1.areObjRefsEqual(itemRef, ref); });
}
function findDrillIntersectionAttributeHeaderItem(drillIntersectionElements, attributeRef) {
    var intersectionForAttribute = drillIntersectionElements.find(function (_a) {
        var header = _a.header;
        return sdk_model_1.isAttributeDescriptor(header) && sdk_model_1.areObjRefsEqual(attributeRef, header.attributeHeader.formOf.ref);
    });
    if (intersectionForAttribute && sdk_ui_1.isDrillIntersectionAttributeItem(intersectionForAttribute.header)) {
        return intersectionForAttribute.header.attributeHeaderItem;
    }
}
function splitDFToLoadingAndMapping(attributesDisplayForms, ctx) {
    var dateAttributes, dateAttributeRefs, _a, _b, displayFormsWithKnownValues, _c, displayFormForValueLoad;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (ctx.backend.capabilities.supportsElementUris) {
                    return [2 /*return*/, {
                            displayFormForValueLoad: attributesDisplayForms,
                            displayFormsWithKnownValues: [],
                        }];
                }
                return [4 /*yield*/, effects_1.select(catalogSelectors_1.selectCatalogDateAttributes)];
            case 1:
                dateAttributes = _d.sent();
                dateAttributeRefs = dateAttributes.map(function (da) { return da.attribute.ref; });
                _a = groupBy_1.default(attributesDisplayForms, function (df) { return isInRefList(dateAttributeRefs, df.attribute); }), _b = _a.true, displayFormsWithKnownValues = _b === void 0 ? [] : _b, _c = _a.false, displayFormForValueLoad = _c === void 0 ? [] : _c;
                return [2 /*return*/, {
                        displayFormsWithKnownValues: displayFormsWithKnownValues,
                        displayFormForValueLoad: displayFormForValueLoad,
                    }];
        }
    });
}
exports.splitDFToLoadingAndMapping = splitDFToLoadingAndMapping;
function loadAttributeElementsForDrillIntersection(drillIntersectionElements, attributesDisplayForms, ctx) {
    var splitDisplayForms, displayFormsWithKnownValues, displayFormForValueLoad, mappedElements, loadedElement;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(splitDFToLoadingAndMapping, attributesDisplayForms, ctx)];
            case 1:
                splitDisplayForms = _a.sent();
                displayFormsWithKnownValues = splitDisplayForms.displayFormsWithKnownValues, displayFormForValueLoad = splitDisplayForms.displayFormForValueLoad;
                mappedElements = displayFormsWithKnownValues.reduce(function (acc, _a) {
                    var dfIdentifier = _a.id, attribute = _a.attribute;
                    var attributeHeaderItem = findDrillIntersectionAttributeHeaderItem(drillIntersectionElements, attribute);
                    if (!attributeHeaderItem) {
                        return acc;
                    }
                    acc.push({
                        identifier: dfIdentifier,
                        elementTitle: attributeHeaderItem.uri,
                    });
                    return acc;
                }, []);
                return [4 /*yield*/, effects_1.all(displayFormForValueLoad.reduce(function (acc, displayForm) {
                        var dfIdentifier = displayForm.id, attribute = displayForm.attribute, dfRef = displayForm.ref;
                        var attributeHeaderItem = findDrillIntersectionAttributeHeaderItem(drillIntersectionElements, attribute);
                        if (!attributeHeaderItem) {
                            return acc;
                        }
                        acc.push(effects_1.call(loadElementTitle, dfRef, dfIdentifier, attributeHeaderItem.uri, ctx));
                        return acc;
                    }, []))];
            case 2:
                loadedElement = _a.sent();
                return [2 /*return*/, tslib_1.__spread(mappedElements, loadedElement)];
        }
    });
}
exports.loadAttributeElementsForDrillIntersection = loadAttributeElementsForDrillIntersection;
var encodeParameterIfSet = function (parameter) {
    return parameter === undefined ? parameter : encodeURIComponent(parameter);
};
function getAttributeDisplayForms(projectId, objRefs, ctx) {
    return ctx.backend.workspace(projectId).attributes().getAttributeDisplayForms(objRefs);
}
exports.getAttributeDisplayForms = getAttributeDisplayForms;
function getAttributeIdentifiersReplacements(url, drillIntersectionElements, ctx) {
    var attributeIdentifiersPlaceholders, displayForms, elements;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                attributeIdentifiersPlaceholders = drillingUtils_1.getAttributeIdentifiersPlaceholdersFromUrl(url);
                if (attributeIdentifiersPlaceholders.length === 0) {
                    return [2 /*return*/, []];
                }
                return [4 /*yield*/, effects_1.call(getAttributeDisplayForms, ctx.workspace, attributeIdentifiersPlaceholders.map(function (placeholder) { return sdk_model_1.idRef(placeholder.identifier); }), ctx)];
            case 1:
                displayForms = _a.sent();
                return [4 /*yield*/, effects_1.call(loadAttributeElementsForDrillIntersection, drillIntersectionElements, displayForms, ctx)];
            case 2:
                elements = _a.sent();
                return [2 /*return*/, attributeIdentifiersPlaceholders.map(function (_a) {
                        var _b;
                        var toBeReplaced = _a.placeholder, identifier = _a.identifier, toBeEncoded = _a.toBeEncoded;
                        var elementTitle = (_b = elements.find(function (element) { return element.identifier === identifier; })) === null || _b === void 0 ? void 0 : _b.elementTitle;
                        var replacement = toBeEncoded ? encodeParameterIfSet(elementTitle) : elementTitle;
                        return {
                            toBeReplaced: toBeReplaced,
                            replacement: replacement,
                        };
                    })];
        }
    });
}
exports.getAttributeIdentifiersReplacements = getAttributeIdentifiersReplacements;
var createIdentifierReplacement = function (toBeReplaced, replacement) {
    if (replacement === void 0) { replacement = ""; }
    return ({ toBeReplaced: toBeReplaced, replacement: replacement, replaceGlobally: true });
};
function getInsightIdentifiersReplacements(customUrl, widgetRef, ctx) {
    var workspace, clientId, dataProductId, dashboardId, widget, insight, replacements;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                workspace = ctx.workspace, clientId = ctx.clientId, dataProductId = ctx.dataProductId;
                return [4 /*yield*/, effects_1.select(metaSelectors_1.selectDashboardId)];
            case 1:
                dashboardId = _a.sent();
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectAnalyticalWidgetByRef(widgetRef))];
            case 2:
                widget = _a.sent();
                return [4 /*yield*/, effects_1.select(insightsSelectors_1.selectInsightByRef(widget.insight))];
            case 3:
                insight = _a.sent();
                replacements = [
                    createIdentifierReplacement(drillTypes_1.DRILL_TO_URL_PLACEHOLDER.PROJECT_ID, workspace),
                    createIdentifierReplacement(drillTypes_1.DRILL_TO_URL_PLACEHOLDER.WORKSPACE_ID, workspace),
                    createIdentifierReplacement(drillTypes_1.DRILL_TO_URL_PLACEHOLDER.DASHBOARD_ID, dashboardId),
                    createIdentifierReplacement(drillTypes_1.DRILL_TO_URL_PLACEHOLDER.CLIENT_ID, clientId),
                    createIdentifierReplacement(drillTypes_1.DRILL_TO_URL_PLACEHOLDER.DATA_PRODUCT_ID, dataProductId),
                    createIdentifierReplacement(drillTypes_1.DRILL_TO_URL_PLACEHOLDER.INSIGHT_ID, sdk_model_1.insightId(insight)),
                ];
                if (customUrl.includes(drillTypes_1.DRILL_TO_URL_PLACEHOLDER.WIDGET_ID)) {
                    return [2 /*return*/, tslib_1.__spread(replacements, [
                            createIdentifierReplacement(drillTypes_1.DRILL_TO_URL_PLACEHOLDER.WIDGET_ID, widget.identifier),
                        ])];
                }
                return [2 /*return*/, replacements];
        }
    });
}
exports.getInsightIdentifiersReplacements = getInsightIdentifiersReplacements;
var applyReplacements = function (url, replacements) {
    return replacements.reduce(function (customUrlWithReplacedPlaceholders, _a) {
        var toBeReplaced = _a.toBeReplaced, replacement = _a.replacement, replaceGlobally = _a.replaceGlobally;
        return customUrlWithReplacedPlaceholders.replace(replaceGlobally ? new RegExp(toBeReplaced, "g") : toBeReplaced, replacement);
    }, url);
};
function resolveDrillToCustomUrl(drillConfig, widgetRef, event, ctx, cmd) {
    var customUrl, attributeIdentifiersReplacements, missingReplacement, insightIdentifiersReplacements, replacements;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                customUrl = drillConfig.target.url;
                return [4 /*yield*/, effects_1.call(getAttributeIdentifiersReplacements, customUrl, event.drillContext.intersection, ctx)];
            case 1:
                attributeIdentifiersReplacements = _a.sent();
                missingReplacement = attributeIdentifiersReplacements.find(function (_a) {
                    var replacement = _a.replacement;
                    return replacement === undefined;
                });
                if (missingReplacement) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Drill to custom URL unable to resolve missing paramter " + missingReplacement.toBeReplaced);
                }
                return [4 /*yield*/, effects_1.call(getInsightIdentifiersReplacements, customUrl, widgetRef, ctx)];
            case 2:
                insightIdentifiersReplacements = _a.sent();
                replacements = tslib_1.__spread(attributeIdentifiersReplacements, insightIdentifiersReplacements);
                return [2 /*return*/, applyReplacements(customUrl, replacements)];
        }
    });
}
exports.resolveDrillToCustomUrl = resolveDrillToCustomUrl;
//# sourceMappingURL=resolveDrillToCustomUrl.js.map